$(function() {
	var transitAnimation = $('.transit-row a');

	var animation1 = false;
	var animation2 = false;

	function animationRight(that) {
		animation1 = true;
		that.find('#focusSvg #line1')
			.velocity({
				'x2': "-1.9",
			}, 0)
			.velocity({
				'x2': "438.1",
			}, 1600, [0.42,0,0,1])

			that.find('#focusSvg #line2')
			.velocity({
				'x1': "841.9",
			}, 0)
			.velocity({
				'x1': "401.9",
			}, 1800, [0.42,0,0,1])

			that.find('#focusSvg #line3')
			.velocity({
				'y1': "610.2"
			}, 0)
			.velocity({
				'y1': "170.2"
			}, 2000, [0.42,0,0,1])

			that.find('#focusSvg #line4')
			.velocity({
				'y2': "233.3"
			}, 0)
			.velocity({
				'y2': "673.3",
			}, 2200, [0.42,0,0,1], function() { 
			       animation1 = false;
			})
	};
	function animationLeft(that) {
		animation2 = true;
		that.find('#expertisesSVG #hookTop')
			.velocity({ 'stroke-dashoffset': '1180' }, 0)
	      	.velocity({ 'stroke-dashoffset': 0 }, 2000, [0.42,0,0,1])
	      	that.find('#expertisesSVG #hookBottom')
			.velocity({ 'stroke-dashoffset': '1180' }, 0)
	      	.velocity({ 'stroke-dashoffset': 0 }, 2000, [0.42,0,0,1], function() { 
			       animation2 = false;
			})
	};

	animationRight(transitAnimation)
	animationLeft(transitAnimation)

	transitAnimation.mouseenter(function() {
		var that = $(this);
		if ((!animation1)&&(that.find("svg").is("#focusSvg"))) {
			animationRight(that)
		}
		if ((!animation2)&&(that.find("svg").is("#expertisesSVG"))) {
			animationLeft(that)			
		}
	});

});
